import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import TermsContent from '../components/TermsContent';
import SiteSections from '../components/SiteSections';

export default function Terms() {
  useEffect(() => {
    document.title = 'Terms & Conditions · PBB';
  }, []);

  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="terms-page">
      <Link
        to="/loyalty"
        className="inline-flex items-center gap-1 text-xs text-green-400 hover:text-green-300"
        data-testid="terms-back-link"
      >
        <ArrowLeft size={14} /> Back to Loyalty
      </Link>

      <header className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full bg-green-600/15 border border-green-600/40 flex items-center justify-center">
          <FileText className="text-green-400" size={20} />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Terms &amp; Conditions</h1>
          <p className="text-gray-400 text-sm">PBB Loyalty Program</p>
        </div>
      </header>

      <div className="pbb-card p-6">
        <TermsContent />
      </div>
      <SiteSections pageKey="terms" />
    </div>
  );
}
